<div class="row col-12 col-sm-12 my-account-container">
    <div class="col-3 col-sm-3 my-account-left-nav">
        <app-my-account-left-sidenav [navState]="'MyOrdersNavNode'"
            [childNavState]="isPosition ? 'OpenPositionsNavNode' : 'OrdersStatusNavNode'">
        </app-my-account-left-sidenav>
    </div>

    <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav" *ngIf="orderDetails">
        <div class="row">
            <div class="col-md-12 back-to-history-outer" style="margin-bottom: 20px;">
                <button (click)="backToHistory()" class="back-history-btn" *ngIf="!isPosition">
                    {{'common.text_account_orderHistory_back'|cxTranslate}}
                    <img class="hover-img" src="/icons/link-grey.svg">
                </button>
                <button (click)="backToOpenPosition()" class="back-history-btn" *ngIf="isPosition">
                    {{'common.text_account_openPositions_back' | cxTranslate }}
                    <img class="hover-img" src="/icons/link-grey.svg">
                </button>
            </div>
        </div>
        <h1 class="manageUserTopHeader m-0">{{'common.order_history_status_details'|cxTranslate}}
        </h1>
        <div class="my-section-box">
            <div class="order-status-details-upper-box">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <span class="bol-text">{{'common.order_history_status'|cxTranslate}}</span>
                        @if (orderDetails?.statusOrderHistory !== 'Shipped') {
                        <span class="mycompnay-registration-value">
                            {{orderDetails?.statusOrderHistory}}
                        </span>
                        } @else {
                        <span class="mycompnay-registration-value"></span>
                        }
                    </div>
                    <div
                        class="col-xs-12 col-sm-12 col-md-12 col-lg-6 order-details-upper-date-outer d-flex justify-content-end">
                        <span
                            class="bol-text">{{'common.order_history_status_date'|cxTranslate}}</span>&nbsp;{{formatDate(statusDate,
                        orderDetails.dateFormat)}}
                    </div>
                </div>
            </div>
            <div class="form-field-control edit-user-form-control my-section-box-inner">


                <div class="my-section-box-inner order-status-details-inner">

                    <div class="order-info-box-outer">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-4">
                                <div class="order-info-box order-text">
                                    <span
                                        class="bold-text">{{'common.order_history_order_date'|cxTranslate}}</span>&nbsp;{{orderDetails.kbcreated}}
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3">
                                <div class="order-info-box order-text">
                                    <span class="bold-text">{{'common.order_history_order_number'|cxTranslate}}</span>
                                    {{orderDetails.code}}
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-5">
                                <div class="order-info-box text-right order-text">
                                    <span class="bold-text">{{'common.order_track_my_status_po'|cxTranslate}}</span>
                                    <span
                                        class="customer-reference-no-value">{{orderDetails.purchaseOrderNumber}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-8">
                            <div class="customer-info-box">
                                <span
                                    class="bold-text">{{'common.order_history_customer_ID'|cxTranslate}}</span><br><br>
                                {{orderDetails?.user?.name}}<br>
                                <span class="blue-text">{{orderDetails?.user?.uid}}</span><br>
                                <!-- unit -->
                                {{orderDetails?.unit?.addresses[0]?.sapCustomerID}}<br>
                                {{orderDetails?.unit?.addresses[0]?.companyName}}<br>
                                {{orderDetails?.unit?.addresses[0]?.line1}},&nbsp;{{orderDetails?.unit?.addresses[0]?.line2}}<br>
                                {{orderDetails?.unit?.addresses[0]?.postalCode}},&nbsp;{{orderDetails?.unit?.addresses[0]?.town}}<br>
                                <span
                                    *ngIf="orderDetails?.unit?.addresses[0]?.region?.name && !orderDetails?.unit?.addresses[0]?.hide0270RegionFlag">{{orderDetails?.unit?.addresses[0]?.region?.name}}<br></span>
                                {{orderDetails?.unit?.addresses[0]?.country?.name}}<br>
                            </div>
                            <div class="order-delivery-type-info-box">
                                <div class="info-box">
                                    <span
                                        class="info-label bold-text">{{'common.order_history_order_type'|cxTranslate}}</span>
                                    <span class="info-type">&nbsp;{{orderDetails.selectedOrderTypeName}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-6 address-infos-div">
                                    <div class="customer-info-box">
                                        <span
                                            class="bold-text">{{'common.order_history_shipping_address'|cxTranslate}}</span><br><br>
                                        {{orderDetails.deliveryAddress?.sapCustomerID}}<br>
                                        {{orderDetails.deliveryAddress?.companyName}}<br>
                                        {{orderDetails.deliveryAddress?.line1}},&nbsp;{{orderDetails.deliveryAddress?.line2}}<br>
                                        {{orderDetails.deliveryAddress?.postalCode}},&nbsp;{{orderDetails.deliveryAddress?.town}}<br>
                                        <span
                                            *ngIf="orderDetails?.deliveryAddress?.region?.name && !orderDetails?.deliveryAddress?.hide0270RegionFlag">{{orderDetails?.deliveryAddress?.region?.name}}<br></span>
                                        {{orderDetails?.deliveryAddress?.country?.name}}<br>

                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-6 address-infos-div">
                                    <div class="customer-info-box">
                                        <span
                                            class="bold-text">{{'common.order_history_billing_address'|cxTranslate}}</span><br><br>
                                        {{orderDetails.paymentAddress?.sapCustomerID}}<br>
                                        {{orderDetails.paymentAddress?.companyName}}<br>
                                        {{orderDetails.paymentAddress?.line1}},&nbsp;{{orderDetails.paymentAddress?.line2}}<br>
                                        {{orderDetails.paymentAddress?.postalCode}},&nbsp;{{orderDetails.paymentAddress?.town}}<br>
                                        <span
                                            *ngIf="orderDetails?.paymentAddress?.region?.name && !orderDetails?.paymentAddress?.hide0270RegionFlag">{{orderDetails?.paymentAddress?.region?.name}}<br></span>
                                        {{orderDetails?.paymentAddress?.country?.name}}<br>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-4">
                            <div class="order-status-re-order-btn-outer d-flex justify-content-end">
                                <button *ngIf="orderDetails.isReorderAllowed" (click)="reorder()"
                                    class="save-btn">{{'common.order_history_reorder_button'|cxTranslate}}
                                    <img class="hover-img" src="/icons/link-grey.svg">
                                </button>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 text-right">
                            <button class="btn btn-primary yellow-btn" (click)="openDialog()"
                                [disabled]="hasTrackingNumber(orderDetails)">
                                {{'common.order_track_my_status'|cxTranslate}}<img class="hover-img"
                                    src="/icons/link-grey.svg" alt="image">
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <ul class="checkout-order-summary-list">

            <div class="mainEntryGroup" *ngFor="let item of orderDetails.entries">

                <li class="checkout-order-summary-list-items d-flex">
                    <div class="thumb">


                        <a [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl" tabindex="0">
                            <cx-media [container]="item.product?.images?.['PRIMARY'] || item.product?.images">
                            </cx-media>
                        </a>


                    </div>
                    <div class="checkout-EntryNumber">
                        {{item.entryNumber}}
                    </div>
                    <div class="details">
                        <div
                            class="checkout-Entryitem-block order-confirmation-order-summary d-flex justify-content-between">
                            <div class="col-xs-12 col-sm-5 col-md-6 line-item">
                                <div class="name">
                                    <a
                                        [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl">{{item.product.code}}</a>


                                </div>
                                <span class="d-block">
                                    {{item.product.typenumber}}
                                </span>
                                <div class="">
                                    <br>
                                    {{item.product.description}}
                                    <br>
                                </div>


                                <div class="checkout-Entryitem-qty">
                                    <span>{{'common.order_track_my_status_qty'|cxTranslate}}
                                    </span>{{item?.formattedQuantity}}&nbsp;&nbsp;
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-7 col-md-6 order-confirmation-price-block">
                                <span *ngIf="fleetPrideGroup">

                                    <span class="checkout-netprice-block" *ngIf="showNetPrice$|async">
                                        <span class="checkout-label-priceLabel">
                                            {{'common.basket_page_customerPrice'|cxTranslate}}
                                        </span>
                                        <span class="checkout-input-price">

                                            <ng-container
                                                *ngIf=" item.product?.netPricePerPiece?.value >= 0;else priceOnRequestText">
                                                {{item.product?.netPrice?.formattedValue}}&nbsp;
                                                {{item.product?.netPrice?.currencyIso}}
                                            </ng-container>
                                            <ng-template #priceOnRequestText>
                                                {{'common.basket_page_poa'|cxTranslate}}
                                            </ng-template>
                                        </span>


                                    </span>
                                    <span class="checkout-netprice-block">

                                    </span>


                                    <span class="checkout-netprice-block" *ngIf="showCorePrice$|async">

                                        <span class="checkout-label-priceLabel">
                                            {{'common.basket_page_coredeposit'|cxTranslate}}
                                        </span>
                                        <span class="checkout-input-price">

                                            <ng-container *ngIf="item?.surcharge?.value>=0;else priceOnRequestText">
                                                {{item?.surcharge?.formattedValue}}&nbsp;
                                                {{item?.surcharge?.currencyIso}}
                                            </ng-container>
                                            <ng-template #priceOnRequestText>
                                                {{'common.basket_page_poa'|cxTranslate}}
                                            </ng-template>
                                        </span>
                                    </span>
                                </span>
                            </div>

                        </div>

                        <!-- <table class="checkout-required-block">
                            <tbody>
                                <tr class="order-status-details-tr-upper">

                                    <td width="20%">
                                        <div class="qty">
                                            <span class="qty">{{'common.basket_page_emea_orderQty'|cxTranslate}} :
                                            </span> <span>{{item.openQty}}</span>
                                        </div>
                                    </td>

                                    <td width="32%" class="checkout-requiredDeliveryDate text-right">
                                        {{'common.cart_page_reqdelivery'|cxTranslate}} : {{item.requestedDeliveryDate}}
                                    </td>

                                    <td width="23%" class="checkout-estimateDeliveryDate text-right">
                                        {{'common.cart_page_estdelivery'|cxTranslate}} :{{item.estimatedDeliveryDate}}
                                        <span class="">
                                        </span>
                                    </td>

                                    <td width="25%" class="text-right">
                                        <span>{{'common.text_account_order_status_title'|cxTranslate}} :
                                        </span>&nbsp;<span class="red-text">{{orderDetails.statusOrderHistory}}</span>
                                    </td>
                                </tr>

                                <tr class="order-status-details-tr">
                                    <td class="ordered-delivered-qty"><span
                                            class="red-text bold-text">{{'common.text_checkout_page_delivered_qty'|cxTranslate}}</span>
                                        <span class="bold-text red-text">{{item.quantity - item.openQty}}</span>
                                    </td>
                                    <td class="checkout-requiredDeliveryDate text-right">
                                    </td>
                                </tr>
  

                                <tr class="order-status-details-tr">
                                    <td class="ordered-delivered-qty">
                                        <span>{{'common.text_checkout_page_delivery_qty'|cxTranslate}}</span>&nbsp;<span
                                            class="red-text">{{item?.scheduleLine?.estimatedQty}}</span>
                                    </td>
                                    <td class="no-padding-td"></td>
                                    <td class="text-right"><span
                                            class="red-text">{{item?.scheduleLine?.estimatedDate}}</span></td>
                                    <td class="no-padding-td"></td>
                                </tr>

                            </tbody>
                        </table> -->
                        <!--    <table class="checkout-required-block"
                            *ngIf="!shouldShowCoreDeposit(item?.entryNumber, item?.posType)">
                            <tbody>
                                <tr class="order-status-details-tr">
                                    <td class="ordered-delivered-qty" width="30%">
                                        <span
                                            class="red-text bold-text">{{'common.text_checkout_page_delivered_qty'|cxTranslate}}</span>&nbsp;
                                        <span class="red-text bold-text">{{item.quantity - item.openQty}}</span>
                                    </td>
                                    <td class="no-padding-td"></td>
                                </tr>


                                <tr class="order-status-details-tr from-schedulines"
                                    *ngIf="item?.scheduleLines.length>0">
                                    <td width="30%">
                                        <span class="qty">{{'common.order_status_emea_OpenQty'|cxTranslate}} </span>
                                        <span>{{item?.scheduleLines[0]?.estimatedQty}}</span>
                                    </td>

                                    <td width="25%" class="checkout-estimateDeliveryDate text-right noestimate-date"
                                        *ngIf="item?.posType !== 'AH' && item?.scheduleLines[0]?.estimatedDate">
                                        {{'common.cart_page_estdelivery'|cxTranslate}} :
                                        {{item?.scheduleLines[0]?.estimatedDate}}<span class="">
                                        </span></td>
                                </tr>

                                <tr class="order-status-details-tr-upper"
                                    *ngIf="(item.openQty-(item?.scheduleLines[0]?.estimatedQty??0)) > 0">

                                    <td width="30%">
                                        <span class="qty">{{'common.order_status_emea_OpenQty'|cxTranslate}} </span>
                                        <span>{{item.openQty-(item?.scheduleLines[0]?.estimatedQty??0)}}</span>
                                    </td>

                                    <td width="25%" class="checkout-estimateDeliveryDate text-right noestimate-date"
                                        *ngIf="item?.posType !== 'AH' && !item?.scheduleLines[1]?.estimatedDate">
                                        {{'common.cart_page_estdelivery'|cxTranslate}} :
                                        {{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}<span class="">
                                        </span></td>

                                    <td width="25%" class="checkout-estimateDeliveryDate text-right noestimate-date"
                                        *ngIf="item?.posType !== 'AH' && item?.scheduleLines[1]?.estimatedDate">
                                        {{'common.cart_page_estdelivery'|cxTranslate}} :
                                        {{item?.scheduleLines[1]?.estimatedDate}}<span class="">
                                        </span></td>

                                    <td width="25%" class="text-right" *ngIf="item?.posType !== 'AH'">
                                        <span>{{'common.text_account_order_status_title'|cxTranslate}} :
                                        </span>&nbsp;<span class="red-text">{{orderDetails.statusOrderHistory}}</span>
                                    </td>
                                </tr>


                               

                                <tr class="red-text bold-text" *ngIf="item.posType=='AH'">
                                    {{'common.checkout_page_replaced'|cxTranslate}}</tr>

                            </tbody>
                        </table> -->
                    </div>
                </li>
                <!-- mychanges -->
                <div class="checkout-order-summary-list-items-qty">
                </div>
            </div>
        </ul>
        <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6">
                <div class="subtotals " *ngIf="fleetPrideGroup && showNetPrice$|async">
                    <div class="subtotal">
                        {{'common.text_account_orderHistory_total'|cxTranslate}}*
                        <span>{{orderDetails.subTotal?.formattedValue}}&nbsp;{{orderDetails.subTotal?.currencyIso}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12">
            <div class="poa-cartpage" *ngIf="fleetPrideGroup && showNetPrice$|async">
                <p class="order-detail-page-bottom-p">
                    {{'common.order_history_cumulative_price'|cxTranslate}}</p>

            </div>
        </div>
        <div class="row">
            <div class="col-md-12 back-to-history-outer" style="margin-top: 20px;">
                <button (click)="backToHistory()" class="back-history-btn" *ngIf="!isPosition">
                    {{'common.text_account_orderHistory_back'|cxTranslate}}
                    <img class="hover-img" src="/icons/link-grey.svg">
                </button>
                <button (click)="backToOpenPosition()" class="back-history-btn" *ngIf="isPosition">
                    {{'common.text_account_openPositions_back' | cxTranslate }}
                    <img class="hover-img" src="/icons/link-grey.svg">
                </button>
            </div>
        </div>
    </div>
</div>